import {WidgetType} from "@dv5/domain"
import type {
    DiagramWidgetData,
    DocumentWidgetData,
    MarkdownWidgetData,
    ShapeWidgetData,
    StickyNoteData,
    TableWidgetData,
    TaskWidgetData,
    TextWidgetData,
    Widget,
} from "@dv5/domain"

export function getWidgetText(widget: Widget): string {
    const unavailable = widget.targetAvailable === false ? ' (Broken link)' : ''
    switch (widget.type) {
        case WidgetType.STICKY_NOTE:
            return (widget.data as StickyNoteData).text
        case WidgetType.TEXT_WIDGET:
            return (widget.data as TextWidgetData).text
        case WidgetType.SHAPE:
            return (widget.data as ShapeWidgetData).text ?? ''
        case WidgetType.MARKDOWN:
            return (widget.data as MarkdownWidgetData).text ?? ''
        case WidgetType.DIAGRAM:
            return (widget.data as DiagramWidgetData).text ?? ''
        case WidgetType.TABLE:
            return (widget.data as TableWidgetData).text ?? ''
        case WidgetType.REACTION:
            return ''
        case WidgetType.DOCUMENT:
            return ((widget.data as DocumentWidgetData).title ?? 'Document') + unavailable
        case WidgetType.TASK:
            return ((widget.data as TaskWidgetData).title ?? 'Task') + unavailable
    }
}

const WIDGET_TYPE_TITLES: Record<WidgetType, string> = {
    [WidgetType.STICKY_NOTE]: 'Sticky Note',
    [WidgetType.TEXT_WIDGET]: 'Text',
    [WidgetType.SHAPE]: 'Shape',
    [WidgetType.REACTION]: 'Reaction',
    [WidgetType.MARKDOWN]: 'Markdown',
    [WidgetType.DIAGRAM]: 'Diagram',
    [WidgetType.TABLE]: 'Table',
    [WidgetType.DOCUMENT]: 'Document',
    [WidgetType.TASK]: 'Task',
}

export function getWidgetTypeTitle(type: WidgetType): string {
    return WIDGET_TYPE_TITLES[type] ?? type
}
